import "./style.scss";

import { FC, useContext } from "react";

import Button from "shared/ui/Button";
import { Button_Type } from "shared/ui/Button/Button";
import { ReactComponent as IconChevronLeft } from "../../assets/img/icons/nav_collapse.svg";
import { ReactComponent as IconChevronRight } from "../../assets/img/icons/icon_carret-Right.svg";
import MenuItems from "../MenuItems";
import MenuProfile from "../MenuProfile";
import { UserContext } from "features/account";
import logo from "../../assets/img/logo_ID-Protect-blanc.png";
import logoIcon from "../../assets/img/logo_ID-Protect-blanc-icon.png";

interface MenuDesktopProps {
    isCollapsed?: boolean;
    setIsCollapsed?: (v: boolean) => void;
}

const MenuDesktop: FC<MenuDesktopProps> = ({ isCollapsed = false, setIsCollapsed }) => {
    const { userType } = useContext(UserContext);

    const toggle = () => setIsCollapsed?.(!isCollapsed);

    return (
        <div className={`aside ${isCollapsed ? "collapsed" : ""}`}>
            <div>
                <div className="aside__header">
                    <a href="/" className="navbar-brand">
                        <img src={isCollapsed ? logoIcon : logo} alt="ID Protect" />
                    </a>
                    <Button
                        isIconButton
                        type={Button_Type.SECONDARY}
                        icon={isCollapsed ? <IconChevronRight fill="#fff" /> : <IconChevronLeft fill="#fff" />}
                        onClick={toggle}
                    />
                </div>
                <MenuItems
                    isCollapsed={isCollapsed}
                    forADV={!!+(process.env.REACT_APP_FOR_ADV || 0)}
                    forSofinco={!!+(process.env.REACT_APP_FOR_PARTNER_ONLY || 0)}
                />
            </div>
            <MenuProfile isCollapsed={isCollapsed} />
        </div>
    );
};

export default MenuDesktop;
